// extracted by mini-css-extract-plugin
export default {"formItem":"src-components-Antd-FormItem-FormItem__formItem--amKLB"};